import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        requestAnimationFrame(() => {
            this.checkChatButton();
        });
    }

    checkChatButton() {
        const chatButton = document.querySelector('.gc-chat-btn');

        if (!chatButton) {
            const parent = this.element.closest('.col');

            if (parent) {
                parent.style.display = 'none';
            }
        }
    }

    open() {
        if (typeof window.openChatWindow === 'function') {
            window.openChatWindow();
        }
    }
}
